export const timezones = ['Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Zurich'];
